import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getProjectStatuses = createAsyncThunk(
  "projectStatuses/getProjectStatuses",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projectStatuses;
      if (state.data.length <= 0 && state.count.getProjectStatuses <= 1) {
        const res = await axios.get("/project-statuses", { params: reqData });
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addProjectStatuses = createAsyncThunk(
  "projectStatuses/addProjectStatuses",
  async ({ reqData, id }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/add-project-status/${id}`, reqData);
      return res.data;
    } catch (error) {
      if (error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const editProjectStatuses = createAsyncThunk(
  "projectStatuses/editProjectStatuses",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`/edit-project-status/${id}`, reqData);
      return res.data;
    } catch (error) {
      if (error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProjectStatuses = createAsyncThunk(
  "projectStatuses/deleteProjectStatuses",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/delete-project-status/${id}`);
      return res.data;
    } catch (error) {
      if (error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const projectStatusesSlice = createSlice({
  name: "projectStatuses",
  initialState: {
    total: 0,
    data: [],
    selected: {},
    loading: false,
    error: null,
    load: {
      getProjectStatuses: false,
      getProjectStatus: false,
      addProjectStatuses: false,
      editProjectStatuses: false,
      deleteProjectStatuses: false,
    },
    count: {
      getProjectStatuses: 0,
      getProjectStatus: 0,
    },
  },
  reducers: {
    setProjectStatuses: (state, action) => {
      state.data = action.payload;
    },
    setSelectedProjectStatus: (state, action) => {
      state.selected = action.payload;
    },
    unsetProjectStatuses: (state) => {
      state.data = [];
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Projects
      .addCase(getProjectStatuses.pending, (state) => {
        state.load.getProjectStatuses = loadStatus.loading;
        state.error = null;
        state.count.getProjectStatuses = ++state.count.getProjectStatuses;
      })
      .addCase(getProjectStatuses.fulfilled, (state, action) => {
        state.load.getProjectStatuses = loadStatus.success;
        state.data = action.payload;
        state.count.getProjectStatuses = 0;
      })
      .addCase(getProjectStatuses.rejected, (state, action) => {
        state.load.getProjectStatuses = loadStatus.error;
        state.error = action.payload;
        state.count.getProjectStatuses = 0;
      })
      //Add Project
      .addCase(addProjectStatuses.pending, (state) => {
        state.load.addProjectStatuses = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProjectStatuses.fulfilled, (state, action) => {
        state.load.addProjectStatuses = loadStatus.success;
        state.data.unshift(action.payload);
      })
      .addCase(addProjectStatuses.rejected, (state, action) => {
        state.load.addProjectStatuses = loadStatus.error;
        state.error = action.payload;
      })
      //Update Project
      .addCase(editProjectStatuses.pending, (state) => {
        state.load.editProjectStatuses = loadStatus.loading;
        state.error = null;
      })
      .addCase(editProjectStatuses.fulfilled, (state, action) => {
        state.load.editProjectStatuses = loadStatus.success;
        const index = state.data.findIndex(
          (project) => (project.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editProjectStatuses.rejected, (state, action) => {
        state.load.editProjectStatuses = loadStatus.error;
        state.error = action.payload;
      })
      //Delete Project
      .addCase(deleteProjectStatuses.pending, (state) => {
        state.load.deleteProjectStatuses = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteProjectStatuses.fulfilled, (state, action) => {
        state.load.deleteProjectStatuses = loadStatus.success;
        state.data.filter((project) => project.id !== action.meta.arg.id);
      })
      .addCase(deleteProjectStatuses.rejected, (state, action) => {
        state.load.deleteProjectStatuses = loadStatus.error;
        state.error = action.payload;
      });
  },
});

export const {
  setProjectStatuses,
  setSelectedProjectStatus,
  unsetProjectStatuses,
} = projectStatusesSlice.actions;
export default projectStatusesSlice.reducer;
